import React, { useEffect, useRef, useState } from 'react';
import { get } from '../../services/apiController';
import { DEBOUNCE_DELAY, TABLE_DEFAULT_LIMIT } from '../../util/constant';
import { Form, Table } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PaginationInPage from '../Pagination';
import Breadcrumb from '../../components/Breadcrumb';
import Factory from '../../components/factory';
import useDebounce from '../useDebounce';
import { GrDocumentExcel } from 'react-icons/gr';
import { get_auth_key, getStoredData } from '../../util';
import Sorter from '../../components/atoms/Sorter';

const CurrentStock = () => {
  const storedData = JSON.parse(getStoredData(get_auth_key()));
  const admins = ['admin', 'super-admin', 'inventory-admin'].includes(storedData.role);
  const [totalRecords, setTotalRecords] = useState(0);
  const [stockDetails, setStockDetails] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [factories, setFactories] = useState([]);
  const [state, setState] = useState({
    factoryId: !admins ? storedData?.locationId[0] || '' : '',
    query: '',
  });
  const [sortedColumn, setSortedColumn] = useState({
    quantity: true,
  });

  const clickToDownload = useRef(null);

  const getStockDetails = (conditionType) => {
    if (conditionType === 'download') {
      get(
        `/inv/stock/?factoryId=${state.factoryId}&query=${state.query}&conditionType=${conditionType}&sortByQuantity=${sortedColumn.quantity}`
      ).then((response) => {
        clickToDownload.current.href = `${process.env.REACT_APP_BASE_URL}/file/download?filePath=${response.data.filePath}`;
        setTimeout(() => {
          clickToDownload.current.click();
        }, 500);
      });
    } else {
      get(
        `/inv/stock/?page=${currentPage}&limit=${TABLE_DEFAULT_LIMIT}&factoryId=${state.factoryId}&query=${state.query}&sortByQuantity=${sortedColumn.quantity}`
      ).then((res) => {
        setStockDetails(res?.data?.rows);
        setTotalRecords(res?.data?.count ?? 0);
      });
    }
  };

  function getFactories() {
    try {
      get(`/branches/?type=factory`).then((response) => {
        setFactories(response?.data?.rows);
      });
    } catch (err) {
      toast.error(err?.response?.data?.data?.message || err?.message);
    }
  }

  useDebounce(
    () => {
      if (currentPage !== 1) {
        setCurrentPage(1);
      } else {
        getStockDetails();
      }
    },
    [state, sortedColumn],
    DEBOUNCE_DELAY
  );

  useEffect(() => {
    getStockDetails();
  }, [currentPage]);

  useEffect(() => {
    getFactories();
  }, []);

  const handleSort = (column) => {
    if (column === 'quantity') {
      sortedColumn[column] === 'asc'
        ? setSortedColumn({
            ...sortedColumn,
            [column]: 'desc',
          })
        : setSortedColumn({
            ...sortedColumn,
            [column]: 'asc',
          });
    }
  };

  return (
    <React.Fragment>
      <ToastContainer />
      <Breadcrumb
        navigation={[
          { link: '#', title: 'Inventory Managment' },
          { link: '#', title: 'Current Stock' },
        ]}
      />
      <div className="card">
        <div className="card-header white-color" style={{ padding: '1rem 1.7rem' }}>
          <h4 className="card-title mb-0" style={{ fontSize: '16px' }}>
            Available Stock | {totalRecords ?? 0}
          </h4>
          <div className="card-header-actions">
            <Factory
              name={'factoryId'}
              factoryId={state.factoryId}
              disabled={!admins}
              label={'Factory'}
              onChange={(e) => setState({ ...state, factoryId: e.target.value })}
              factories={factories}
            />
            <Form.Control
              value={state.query}
              onChange={(e) => setState({ ...state, query: e.target.value })}
              type="search"
              placeholder="Search by item name"
              style={{ width: '250px', marginLeft: '20px', marginRight: '10px' }}
            />
            {totalRecords > 0 && (
              <GrDocumentExcel
                onClick={() => getStockDetails('download')}
                style={{ width: '70px', height: '30px', cursor: 'pointer' }}
                title="Download current Fstock report"
                className="react-icons green"
              />
            )}
            <a ref={clickToDownload} href="" target="_blank" className="hiddenItem">
              HiddenClick{' '}
            </a>
          </div>
        </div>

        <div className="btn-wrapper ">
          {totalRecords === 0 && (
            <div className="container d-flex align-items-center justify-content-center">
              <h5 className="text-danger">No Records Found</h5>
            </div>
          )}
        </div>

        {totalRecords > 0 && (
          <div className="card-body px-0 vehicle-requests-table pt-0 pb-0">
            <div className="row">
              <div className="col">
                <Table responsive striped bordered>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Item</th>
                      <th>Factory</th>
                      <th className="d-flex" onClick={() => handleSort('quantity')}>
                        Stock <Sorter sort={sortedColumn.quantity} />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {stockDetails?.map((item, index) => (
                      <tr key={index}>
                        <td>{(currentPage - 1) * TABLE_DEFAULT_LIMIT + (index + 1)}</td>
                        <td>
                          {item?.Item?.name} ({item?.Item?.unit})
                        </td>
                        <td>{item?.Branch?.name}</td>
                        <td>{item?.quantity}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
                <PaginationInPage
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  totalRecords={totalRecords}
                  TABLE_DEFAULT_LIMIT={TABLE_DEFAULT_LIMIT}
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export default CurrentStock;
